export default __webpack_public_path__ + "static/media/criticalNotificationSound.31200a7e.mp3";